import { Checkbox, Col, Form, Row } from "antd";
import { FC } from "react";
import InputPrice from "../../../components/form/inputPrice";
import LeasingStore from "../../../contexts/leasingStore";
import _t from "../../../lang/translate";
import format from "../../../utilities/formatNumbers";

const LeasingVehiclePrice: FC = () => {
  const { leasingCase } = LeasingStore.useContainer();
  const { readonly, inputLocked } = leasingCase.flags;
  const disabled = readonly || inputLocked;

  return (
    <Form.Item className="mb-2" label={<strong>{_t("purchase_price")}</strong>}>
      <Form.Item name={["input", "effectiveVehiclePrice"]} hidden>
        <InputPrice disabled />
      </Form.Item>
      <Row align="middle" gutter={16}>
        <Col flex="1 1 0">
          <Form.Item
            shouldUpdate={(prev, next) => prev["input"]?.isVatDeadVehicle !== next["input"]?.isVatDeadVehicle
              || prev?.input?.isFullTaxMethod !== next?.input?.isFullTaxMethod
              || prev?.input?.taxPrice !== next?.input?.taxPrice
            }
            noStyle
          >
            {({ getFieldValue }) => {
              const isVatDeadVehicle = getFieldValue(["input", "isVatDeadVehicle"]);
              const taxPrice = getFieldValue(["input", "taxPrice"]);
              const priceIncludesTax = getFieldValue(["input", "priceIncludesTax"])
              const isFullTax = getFieldValue(["input", "isFullTaxMethod"]);
              const vehiclePrice = getFieldValue(["input", "vehiclePrice"]);
              const effectiveVehiclePrice = getFieldValue(["input", "effectiveVehiclePrice"]);
              return (
                <>
                  <Form.Item name={["input", "vehiclePrice"]} rules={[{ required: true }]} className="mb-0">
                    <InputPrice
                      disabled={disabled}
                      min={0}
                      style={{ minWidth: 160 }}
                      suffix={<small>{_t(isVatDeadVehicle ? "include_short" : "exclude_short", "vat")}</small>}
                    />
                  </Form.Item>
                  {(isFullTax && !priceIncludesTax) && (
                    <small style={{ position: "absolute", top: "100%" }}>{format.number(vehiclePrice || 0)} + {format.number(taxPrice || 0)} = <span className="text-medium">{format.number(effectiveVehiclePrice)}</span></small>
                  )}
                </>
              );
            }}
          </Form.Item>
        </Col>
        <Col flex="0 0 auto">
          <Form.Item name={["input", "isVatDeadVehicle"]} valuePropName="checked" noStyle>
            <Checkbox disabled={disabled} tabIndex={20}>
              {_t("taxDead")}
            </Checkbox>
          </Form.Item>
          <Form.Item name={["input", "priceIncludesTax"]} valuePropName="checked" noStyle>
            <Checkbox disabled={disabled} tabIndex={20}>
              {_t("include_short", "tax_fee")}
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>
    </Form.Item>
  );
};

export default LeasingVehiclePrice;
